<div class="container">
    <div *ngIf="!this.isAttending && !hasFields" class="modal-wrapper">
        <ng-template [ngIf]="!isWithPartner">
            <h1>{{ "event.confirm.title" | translate }}</h1>
            <span>{{ "event.confirm.description" | translate }}</span>
        </ng-template>
        <ng-template [ngIf]="isWithPartner">
            <h1>{{ "event.confirm.title-partner" | translate }}</h1>
            <span>{{ "event.confirm.description-partner" | translate }}</span>
        </ng-template>
        <div *ngIf="isWithPartner" class="select-button-wrapper">
            <ion-button
                (click)="numberOfParticipants = 1"
                class="select-btn"
                expand="full"
            >
                {{ "event.confirm.without-partner" | translate }}
            </ion-button>
            <ion-button
                (click)="numberOfParticipants = 2"
                class="select-btn"
                expand="full"
            >
                {{ "event.confirm.with-partner" | translate }}
            </ion-button>
        </div>
        <div class="confirm-btn-wrapper">
            <ion-button (click)="dismiss()" class="select-btn" expand="full">
                {{ "expenses.cancel" | translate }}
            </ion-button>
            <ion-button
                (click)="toggleAttend()"
                class="confirm-btn"
                expand="full"
            >
                {{ attendButtonText | translate }}
            </ion-button>
        </div>
    </div>
    <div *ngIf="!this.isAttending && hasFields" class="modal-wrapper">
        <h1>{{ "event.extended.title" | translate }}</h1>

        <ng-container *ngFor="let field of fields">
            <div *ngIf="field.type === 'option'" class="field-group">
                <span class="field-label">{{ field.label | translate }}</span>
                <div class="category-select">
                    <button
                        *ngFor="let option of field.options"
                        (click)="selectOption(field, option.value)"
                        [class.active]="values[field.key] === option.value"
                        class="category-btn"
                        type="button"
                    >
                        {{ option.label | translate }}
                    </button>
                </div>
            </div>

            <div *ngIf="field.type === 'number'" class="steppers">
                <div class="stepper">
                    <span class="stepper-label">
                        {{ field.label | translate }}
                    </span>
                    <div class="stepper-controls">
                        <button
                            (click)="decrement(field)"
                            [disabled]="!canDecrement(field)"
                            class="stepper-btn"
                            type="button"
                        >
                            −
                        </button>
                        <span class="stepper-value">
                            {{ values[field.key] }}
                        </span>
                        <button
                            (click)="increment(field)"
                            [disabled]="!canIncrement(field)"
                            class="stepper-btn"
                            type="button"
                        >
                            +
                        </button>
                    </div>
                </div>
            </div>
        </ng-container>

        <span *ngIf="participantLimit !== null" class="total-label">
            {{
                "event.extended.total"
                    | translate
                        : { total: participantTotal, max: participantLimit }
            }}
        </span>

        <div class="confirm-btn-wrapper">
            <ion-button (click)="dismiss()" class="select-btn" expand="full">
                {{ "expenses.cancel" | translate }}
            </ion-button>
            <ion-button
                (click)="toggleAttend()"
                [disabled]="!isValid"
                class="confirm-btn"
                expand="full"
            >
                {{ "event.extended.confirm" | translate }}
            </ion-button>
        </div>
    </div>
    <div *ngIf="this.isAttending" class="modal-wrapper">
        <h1>{{ "event.confirm.title-negative" | translate }}</h1>
        <span>{{ "event.confirm.description-negative" | translate }}</span>
        <div class="confirm-btn-wrapper">
            <ion-button (click)="dismiss()" class="select-btn" expand="full">
                {{ "expenses.cancel" | translate }}
            </ion-button>
            <ion-button
                (click)="toggleAttend()"
                class="confirm-btn"
                expand="full"
            >
                {{ "event.confirm.button-negative" | translate }}
            </ion-button>
        </div>
    </div>
</div>
